import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { Toaster, toast } from "sonner";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { UsersRound } from "lucide-react";
import { API } from "@/lib/api";
import { ADMIN_TOKEN_KEY } from "@/lib/constants";

export default function InvitePage() {
  const { token } = useParams();
  const [info, setInfo] = useState(null);
  const [error, setError] = useState("");
  const [name, setName] = useState("");
  const [password, setPassword] = useState("");
  const [password2, setPassword2] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    axios.get(`${API.replace("/api", "")}/api/auth/invite/${token}`)
      .then((r) => setInfo(r.data))
      .catch((e) => setError(e.response?.data?.detail || "Einladung konnte nicht geladen werden"));
  }, [token]);

  const accept = async (e) => {
    e.preventDefault();
    if (password.length < 8) { toast.error("Passwort muss mind. 8 Zeichen haben"); return; }
    if (password !== password2) { toast.error("Passwörter stimmen nicht überein"); return; }
    setBusy(true);
    try {
      const r = await axios.post(`${API.replace("/api", "")}/api/auth/accept-invite`, { token, password, name });
      localStorage.setItem(ADMIN_TOKEN_KEY, r.data.token);
      toast.success("Willkommen im Team!");
      window.location.href = "/app";
    } catch (err) {
      toast.error(err.response?.data?.detail || "Beitritt fehlgeschlagen");
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-[var(--brand-bg)] flex items-center justify-center p-4 font-[Inter]">
      <Toaster richColors position="top-right" />
      <Card className="w-full max-w-md p-8 border-[var(--brand-border)]" data-testid="invite-page">
        <div className="flex items-center gap-2 mb-2">
          <UsersRound className="w-6 h-6 text-[var(--brand-primary)]" />
          <h1 className="font-[Playfair_Display] text-2xl font-semibold text-[var(--brand-ink)]">Team-Einladung</h1>
        </div>
        {error ? (
          <p className="text-sm text-red-600 mt-3" data-testid="invite-error">{error}</p>
        ) : !info ? (
          <p className="text-sm text-[var(--brand-muted)] mt-3">Lädt Einladung …</p>
        ) : (
          <>
            <p className="text-sm text-[var(--brand-muted)] mb-5" data-testid="invite-info">
              <b>{info.invited_by}</b> hat dich als <b>{info.role === "admin" ? "Admin" : "Mitarbeiter"}</b> zum Team von <b>{info.company_name || "einem Unternehmen"}</b> eingeladen. Lege ein Passwort fest, um beizutreten.
            </p>
            <form onSubmit={accept} className="space-y-4">
              <div>
                <Label>E-Mail</Label>
                <Input value={info.email} disabled data-testid="invite-email" />
              </div>
              <div>
                <Label>Dein Name</Label>
                <Input value={name} onChange={(e) => setName(e.target.value)} placeholder="Vor- und Nachname" data-testid="invite-name" />
              </div>
              <div>
                <Label>Passwort (mind. 8 Zeichen)</Label>
                <Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="invite-password" />
              </div>
              <div>
                <Label>Passwort wiederholen</Label>
                <Input type="password" value={password2} onChange={(e) => setPassword2(e.target.value)} data-testid="invite-password2" />
              </div>
              <Button type="submit" disabled={busy} className="w-full bg-[var(--brand-primary)] hover:bg-[var(--brand-primary-dark)] text-white" data-testid="invite-submit">
                {busy ? "Tritt bei …" : "Einladung annehmen & loslegen"}
              </Button>
            </form>
          </>
        )}
      </Card>
    </div>
  );
}
